import { useEffect } from 'react'
import { isAppWebsite } from './helpers'

/**
 * Set the title of web page using this hook
 */
export const useHTMLTitle: (
  title: string | string[] | (() => string | string[]) | undefined,
  seperator?: string
) => void = (title, seperator = '•') => {
  const appName = isAppWebsite ? 'Skit.ai' : 'Studio'
  const suffix = ` ${seperator} ${appName}`

  useEffect(() => {
    if (typeof title === 'string') {
      document.title = title + suffix
    } else if (Array.isArray(title)) {
      document.title = title.join(` ${seperator} `) + suffix
    } else if (typeof title === 'function') {
      const pagetitle = title()
      if (typeof pagetitle === 'string') {
        document.title = pagetitle + suffix
      } else if (Array.isArray(pagetitle)) {
        document.title = pagetitle.join(` ${seperator} `) + suffix
      }
    } else {
      document.title = appName
    }

    return () => {
      document.title = appName
    }
  }, [title, seperator, suffix, appName])
}
